import { DatabaseEnum, DatabaseManager, ServiceProgramDatabase } from "@robotical/analytics-gatherer";

const serviceProgramFirebaseConfig = {
    apiKey: "AIzaSyCbWTuFNqK62vm3d9Q1sR56ChB2yo36DrI",
    authDomain: "service-program-users.firebaseapp.com",
    databaseURL: "https://service-program-users-default-rtdb.firebaseio.com",
    projectId: "service-program-users",
    storageBucket: "service-program-users.appspot.com",
    messagingSenderId: "731474380079",
    appId: "1:731474380079:web:0ce9d28c6b4d148af74dda",
    email: "dev@robotical.io",
    password: "martyRocks",
};

export const isSerialNumberRegistered = async (serialNo: string): Promise<boolean> => {
    try {
        const dbManager = DatabaseManager.getInstance();
        const dbInstance = await dbManager.initializeOrGetDatabase(
            DatabaseEnum.SERVICE_PROGRAM, serviceProgramFirebaseConfig, DatabaseEnum.SERVICE_PROGRAM
        ) as ServiceProgramDatabase;
        return dbInstance.isSerialNumberRegistered(serialNo);
    } catch (error) {
        console.error(`Failed to check if serial number is registered: ${error}`);
        return false;
    }
};
